export const OUTLET_CUISINE = 'cuisine';
export const OUTLET_TYPE = 'type';
export const OUTLET_CITIES = 'cities';
export const OUTLET_DATA = 'allOutlets';
export const OUTLET_COUNTRY = 'country';
